// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"0e840d77","107":"fa084155","230":"119998da","239":"05d1037d","453":"926f0775","488":"fa084155","600":"37a92f36","726":"3f3bafb2","739":"db246194"}[chunkId] + ".chunk.js";
};